export const DEVICE_KAUTION = 50.0;

export const DEVICES = {
  "parkett-poliermaschine": {
    slug: "parkett-poliermaschine",
    category: "Geräte mieten",
    tag: "Bodenbearbeitung",
    cardInfo:
      "Einscheibenmaschine zum Ölen, Reinigen & Polieren von Holz- & Parkettböden.",
    shortTitle: "Parkett Poliermaschine",
    title: "Parkett Poliermaschine / Einscheibenmaschine mieten",
    subline:
      "Die ideale Lösung zum Reinigen, Ölen, Polieren und leichten Schleifen von Holz-, Dielen- und Parkettböden.",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_anhanger-gear/artifacts/182195d30061b28a_Parkett%20Poliermaschine.jpg",
    description:
      "Bringe deine Holz- und Parkettböden wieder zum Strahlen! Mit unserer professionellen Einscheibenmaschine gelingt das Reinigen, Ölen, Polieren und Einarbeiten von Pflegemitteln mühelos – ideal für Heimwerker und Profis.",
    highlights: [
      "Inklusive Treibteller / Padhalter",
      "Einfache & ergonomische Handhabung ohne Vorkenntnisse",
      "Perfekt zum Auftragen von Pflegeöl, Hartwachsöl oder zur Grundreinigung",
      "Für Parkett-, Dielen-, Holz- und Vinylböden geeignet",
    ],
    pricing: {
      "4h": 19.0,
      "24h": 25.0,
      weekend: 39.0,
      week: 89.0,
    },
    accessories: {
      title: "Optionales Zubehör (Polierpads)",
      text: "Passende 12-Zoll Polierpads können direkt bei der Abholung erworben werden. Nicht benutzte, unbeschädigte Pads nehmen wir bei der Rückgabe kostenlos zurück!",
      options: [
        { name: "Polierpad einzeln (Weiß, Rot oder Grün)", price: "€ 6,50 / Stk." },
        { name: "3er-Set Polierpads (nach Wahl)", price: "€ 18,00" },
      ],
    },
    specCards: [
      {
        title: "Gerätedaten",
        highlight: false,
        specs: [
          { label: "Kategorie", value: "Bodenbearbeitung / Poliermaschine" },
          { label: "Marke", value: "Floorboy / Overmat" },
          { label: "Modell", value: "XL350" },
          { label: "Spannung", value: "230 V / 50 Hz" },
          { label: "Leistung", value: "250 W" },
          { label: "Arbeitsbreite", value: "350 mm" },
          { label: "Drehzahl", value: "ca. 1.400 U/min" },
          { label: "Gewicht", value: "ca. 13,9 kg" },
        ],
      },
      {
        title: "Ausstattung & Einsatzbereich",
        highlight: true,
        specs: [
          { label: "Ausstattung", value: "Inklusive Treibteller / Padhalter" },
          { label: "Geeignet für", value: "Parkett-, Dielen-, Holz- und Vinylböden" },
          { label: "Einsatzbereiche", value: "Ölen, Polieren, Pflegen & Grundreinigung" },
        ],
      },
    ],
  },
  "wandschleifer": {
    slug: "wandschleifer",
    category: "Geräte mieten",
    tag: "Trockenbau & Renovierung",
    cardInfo:
      "Ergonomische Schleifgiraffe (225 mm) für Trockenbau-, Wand- & Deckenarbeiten.",
    shortTitle: "Wandschleifer",
    title: "Wand- & Deckenschleifer (Schleifgiraffe) mieten",
    subline:
      "Effizientes und staubarmes Schleifen von Wänden, Decken und Trockenbauelementen.",
    image:
      "https://customer-assets-v7afamib.emergentagent.net/job_anhanger-gear/artifacts/feadecad6133399b_Wandschleifer.png",
    description:
      "Egal ob Renovierung oder Neubau – mit unserer leistungsstarken Schleifgiraffe schleifst du Spachtelmasse, Rigips- und Gipskartonwände kraftschonend und glatt.",
    highlights: [
      "Schleifteller-Durchmesser: 225 mm",
      "Integrierter Absauganschluss für Staubsauger (nahezu staubfreies Arbeiten)",
      "Ergonomisches Design für komfortables Arbeiten an Decken und hohen Wänden",
      "Spart Zeit und Kraft bei Maler- und Spachtelarbeiten",
    ],
    pricing: {
      "4h": 17.0,
      "24h": 23.0,
      weekend: 35.0,
      week: 79.0,
    },
    accessories: {
      title: "Optionales Zubehör (Schleifpapier 225 mm)",
      text: "Passendes Klett-Schleifpapier (225 mm) in verschiedenen Körnungen (K80, K120, K180, K240) direkt mitnehmen. Abrechnung erfolgt nach tatsächlichem Verbrauch!",
      options: [
        { name: "Schleifscheibe einzeln", price: "€ 1,50 / Stk." },
        { name: "10er-Set Schleifscheiben (gemischt)", price: "€ 12,00" },
      ],
    },
    specCards: [
      {
        title: "Gerätedaten",
        highlight: false,
        specs: [
          { label: "Kategorie", value: "Trockenbau & Renovierung" },
          { label: "Marke", value: "Bosch Professional" },
          { label: "Modell", value: "GTR 55-225" },
          { label: "Nennaufnahmeleistung", value: "550 W" },
          { label: "Schleifteller-Ø", value: "225 mm" },
          { label: "Leerlaufdrehzahl", value: "340 – 910 U/min" },
          { label: "Gewicht", value: "ca. 4,8 kg" },
        ],
      },
      {
        title: "Ausstattung & Besonderheiten",
        highlight: true,
        specs: [
          { label: "Ausstattung", value: "Flexibler Schleifkopf, Transportkoffer" },
          { label: "Absauganschluss", value: "Vorhanden (für Staubsaugeranschluss)" },
          { label: "Einsatzbereiche", value: "Spachtelmasse, Rigips, Gipskarton & Malerarbeiten" },
        ],
      },
    ],
  },
};

export const DEVICE_LIST = Object.values(DEVICES);

export const PERIOD_LABELS = {
  "4h": "4 Stunden",
  "24h": "24 Stunden",
  weekend: "Wochenende",
  week: "1 Woche",
};
